import { AnyAction, Reducer, combineReducers, createStore } from 'redux';
import { layoutReducer } from './sideBarStore/layoutStore';
import { authReducer } from './auth/auth';
import { apiSlice } from '../api';
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { rtkQueryErrorMiddleware } from './middlewares';
import { notificationsReducer } from './notifications/notifications';

const combinedReducer = combineReducers({
  layout: layoutReducer,
  auth: authReducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
  notification: notificationsReducer,
});

const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
  if (action.type === 'auth/logout') {
    state = {} as RootState;
  }
  return combinedReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat([
      apiSlice.middleware,
      rtkQueryErrorMiddleware,
    ]),
  devTools: process.env.NODE_ENV !== 'production',
});

setupListeners(store.dispatch);

export default store;

export type AppStore = typeof store;
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof combinedReducer>;
